import { defaults, allowed } from '../../../../lib/genericReducer';

export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    responseMessage: null,
    property_rainfalls: {},
  },
  action
) {
  const types = ['PROPERTY_RAINFALL'];
  if (!allowed(types, action)) return state;

  state = {
    ...state,
    ...defaults(action),
  };

  switch (action.type) {
    case 'FETCH_PROPERTY_RAINFALLS_FULFILLED': {
      return {
        ...state,
        property_rainfalls: action.payload,
      };
    }
    default:
      break;
  }

  return state;
}
